export const serializeFormData = (form) => {
    const formData = new FormData(form);
    let serializedData = {};

    for (let [name, value] of formData) {
        if (serializedData[name]) {
            if (!Array.isArray(serializedData[name])) {
                serializedData[name] = [serializedData[name]];
            }
            if (value !== '') {
                serializedData[name].push(value);
            }
        } else {
            if (value !== '') {
                serializedData[name] = value;
            }
        }
    }
    return serializedData;
}